import { Navigate } from "react-router-dom";

/** /super_admin/settings has no page of its own: send people to the first settings page. */
export default function SettingsIndexRedirect() {
  return <Navigate to="/super_admin/settings/portal_settings" replace />;
}
